function fn_comp_people() {
    var $fn = $(".comp_people"),
        $slider = $fn.find("[data-slider]"),
        $slider_autoplay = $slider.data("slider");

    $slider.slick({
        infinite: false,
        autoplay: true,
        autoplaySpeed: $slider_autoplay,
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev icon--chevron-left"></button>',
        nextArrow: '<button type="button" class="slick-next icon--chevron-right"></button>',
        speed: 500,
        touchMove: true,
        draggable: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}